import React, { ReactNode } from 'react';
import { ReactComponent as FileExtensionIconSvg } from 'assets/file-extension-icon.svg';
import './FileExtensionIcon.pcss';

type Props = {
  children?: ReactNode | Element[] | string;
};

export const FileExtensionIcon = (props: Props) => {
  const { children } = props;

  return (
    <div className="file-extension-icon">
      <FileExtensionIconSvg className="file-extension-icon__icon" />

      {children && <div className="file-extension-icon__text">{children}</div>}
    </div>
  );
};
